import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { primary, gray } from 'styles/colors'
import { header5 } from 'styles/texts'

const buttonStyle = `
  ${header5};
  flex-grow: 1;
  flex-basis: 1px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:focus {
    text-decoration: underline
  }
`
const Button = styled.button`
  ${buttonStyle};
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: ${props => (props.active ? primary : gray)};
`

const LinkButton = styled(Link)`
  ${buttonStyle};
  text-decoration: none;
  color: ${props => (props.active ? primary : gray)};
`

export default ({ to, ...rest }) => {
  if (to) {
    return <LinkButton to={to} {...rest} />
  } else {
    return <Button {...rest} />
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsultantList/Consultant/Button.js